
import { defineComponent } from "vue";

export default defineComponent({
  name: "FooterGTop",
  setup() {
    const getCurrentYear = (): number => {
      const currentDate = new Date();

      return currentDate.getFullYear();
    };

    return {
      getCurrentYear
    };
  }
});
